<template>
  <div class="orderPayment" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <div class="success-information">
        <div class="pay-newinformation">
          <h5><span></span>感謝您在本店購物，您的訂單已提交成功！</h5>
          <p> 訂單信息：<span v-for="(item,index) in goodsData" :key="item.id">{{index + 1}}.&nbsp;&nbsp;{{item.goods_name}} X {{item.goods_number}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </p>
          <p> 收件人：<span>{{orderList.consignee}}</span></p>
          <p> 收件信息：<span>{{orderList.province}}{{orderList.city}}{{orderList.district}}{{orderList.address}}</span></p>
          <p> 移動電話：<span>{{orderList.tel}}</span></p>
          <p> 訂單備註：<span>{{orderList.remark}}</span></p>
        </div>
        <div class="pay-newmoney">
          <span>支付金額：<b>¥ {{orderList.payment_amount}}</b><br></span>
        </div>
        <div class="pay_style">
          <h4 class="shop-formTitle">支付方式</h4>
          <!--ips-->
          <div class="wz">
            <el-radio-group v-model="radioS">
              <el-radio
                v-for="item in ipsPaymentMethod"
                v-if="item.method.platform != -1"
                :label="item.method.method_val"
                :key="item.id"
                @change="payShop(item)">
                <img :src="item.imgSrc">
              </el-radio>
            </el-radio-group>
            <div class="wz radio"
                 v-if="(balance.method.platform != -1 && parseFloat(is_counselor) == 1) &&　surplus　!= 0">
              <el-radio-group v-model="radioS">
                <el-radio :label="balance.tit" @change="payShop()">
                  <div class="yue">
                    <el-row>
                      <el-col :span="10">
                        <img src="../../assets/icon/pay-yue.png" alt="">
                      </el-col>
                      <el-col :span="14">
                        <span>{{balance.tit}}</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-radio>
              </el-radio-group>
              <p v-if="ifBalance" class="dang">當前可用餘額為：<span>&yen;{{surplus}}</span></p>
            </div>
          </div>
          <!--支付宝-->
          <!--       <div v-if="ifAlipay" class="wz">
                   <el-radio-group v-model="radioS">
                     <el-radio
                       v-for="item in aliPaymentMethod"
                       :label="item.method"
                       :key="item.value"
                       @change="payShop()">
                       <img :src="item.imgSrc">
                     </el-radio>
                   </el-radio-group>
                 </div>-->
          <!--余额支付-->
          <!--          <div class="wz radio">
                      <el-radio-group v-model="radioS">
                        <el-radio :label="balance[0]" @change="payShop()">
                        </el-radio>
                      </el-radio-group>
                      <p v-if="ifBalance" class="dang">當前可用餘額為：<span>&yen;22</span></p>
                    </div>-->
        </div>
        <!--        <form id="PayForm" name="dataPay" method="post" :action="post_url" >
                  &lt;!&ndash;支付数据&ndash;&gt;
                  <div style="display:none" v-if="dataPay && post_url">
                    <input type="hidden" name="Mer_code" :value="dataPay.Mer_code"/>
                    <input type="hidden" name="Billno" :value="dataPay.Billno"/><br/>
                    <input type="hidden" name="Amount" :value="dataPay.Amount"/><br/>
                    <input type="hidden" name="Date" :value="dataPay.Date"/><br/><br/>
                    <input type="hidden" name="Currency_Type" :value="dataPay.Currency_Type"/><br/>
                    <input type="hidden" name="Gateway_Type" :value="dataPay.Gateway_Type"/><br/>
                    <input type="hidden" name="Lang" :value="dataPay.Lang"/><br/>
                    <input type="hidden" name="Rettype" :value="dataPay.Rettype"/><br/>
                    <input type="hidden" name="ServerUrl" :value="dataPay.ServerUrl"/><br/>
                    <input type="hidden" name="Merchanturl" :value="dataPay.Merchanturl"/><br/>
                    <input type="hidden" name="OrderEncodeType" :value="dataPay.OrderEncodeType"/><br/>
                    <input type="hidden" name="SignMD5" :value="dataPay.SignMD5"/><br/>
                    <input type="hidden" name="RetEncodeType" :value="dataPay.RetEncodeType"/><br/>
                  </div>

                  <div class="pay_btnBox" >
                    <button class="btn btn-primary "
                            id="pay_nowBtn"
                            formtarget="_blank"
                            :type="types"
                            @click="ifPay()">立即支付</button>
                  </div>

                </form>-->
        <div v-html="formData"></div>
        <div class="pay_btnBox">
          <button class="btn btn-primary "
                  id="pay_nowBtn"
                  formtarget="_blank"
                  type="button"
                  @click="ifPay()">立即支付
          </button>
        </div>
      </div>
    </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
    <!--交易密码弹框-->
    <el-dialog title="余额支付验证" :visible.sync="dialogFormVisible" :lockScroll="false">
      <el-form :label-width="formLabelWidth">
        <el-form-item label="交易手机号" required>
          <el-input type="text" v-model="pay_phone" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <el-form :label-width="formLabelWidth">
        <el-form-item label="输入验证码" required>
          <el-input type="text" v-model="pay_code" auto-complete="off">
            <template slot="append">
              <el-button type="success" @click="SendMsg">{{codetext}}</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="balanceConfirmation">確定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
	import NavB from '@/pages/detailsPage/NavB'
	//common.js
	import { getLocalStorage, setLocalStorage, ifSignIn } from '@/utils/common';
	//api
	import { payOrder, checkPay, orderMsg } from '@/api/order';
	import { userInformation } from '@/api/authentication';
	import { Loading } from 'element-ui';
	//api
	import { signIn, signInCode, signInDynamic } from '@/api/signIn';
	import { getCaptcha } from '@/api/getCode';
	import md5 from 'js-md5'

	export default {
		name: 'OrderPayment',
		components: {
			NavB
		},
		data() {
			return {
				radioS: undefined,
				titleChild: [ { name: '訂單支付', src: 'OrderPayment' } ],
				//ips
				ipsPaymentMethod: [
					{ imgSrc: require( '../../assets/icon/pay-stylepic3.jpg' ), method: {} },//微信
					{ imgSrc: require( '../../assets/icon/pay-stylepic6.jpg' ), method: {} }, //支付宝
					{ imgSrc: require( '../../assets/icon/pay-stylepic4.jpg' ), method: {} },//借记卡
					{ imgSrc: require( '../../assets/icon/pay-stylepic.jpg' ), method: {} },//信用卡
					{ imgSrc: require( '../../assets/icon/pay-stylepic2.jpg' ), method: {} },//国际信用卡
				],
				//支付宝
				aliPaymentMethod: [
//          {imgSrc:require('../../assets/icon/pay-stylepic3.jpg'),method:4},//微信
//          {imgSrc:require('../../assets/icon/pay-stylepic6.jpg'),method:2}, //支付宝
//          {imgSrc:require('../../assets/icon/pay-stylepic4.jpg'),method:1},//借记卡
//          {imgSrc:require('../../assets/icon/pay-stylepic.jpg'),method:4},//信用卡
//          {imgSrc:require('../../assets/icon/pay-stylepic2.jpg'),method:3},//国际信用卡
				],
				//余额
				balance: {
					tit: '餘額支付',
					method: {}
				},
				//支付
				payMsg: null,
				dataPay: null,
				post_url: null,
				//支付按钮属性
				types: 'button',
				//ips和apliay的显示方式
				ifIps: false,
				ifAlipay: false,
				//支付form
				formData: '',
				//控制余额支付
				ifBalance: false,
				// 交易密码弹框
				dialogFormVisible: false,
				formLabelWidth: '120px',
				// 手机号
				pay_phone: undefined,
				// 订单id
				order: this.$route.query.id,
				surplus: undefined,
				// 判断是否可以余额支付
				is_counselor: undefined,
				// 验证码
				codetext: '发送验证码',
				pay_code: '',
				code: undefined,
				canSend: true,
//      use_points:this.$route.query.use_points,
				// 详情数据
				orderList: {},
				goodsData: []
			}
		},
		methods: {
			SendMsg() {
				// getCaptcha().then(res =>{
				var objData = {
					username: this.pay_phone,
					// captcha_key: res.data.captcha_key,
					// captcha_code: res.data.code,
					action: 'payment'
				}
				if ( this.canSend ) {
					signInCode( objData ).then( res => {
						this.code = res.data.code
						var time = 60
						window.t = window.setInterval( () => {
							console.log( window.t )
							if ( time <= 0 ) {
								for ( var i = 0; i < 1000; i++ ) {
									window.clearInterval( i )
								}
								this.codetext = '发送验证码'
								this.canSend = true
							} else {
								this.codetext = '重新发送(' + time + 's)'
								this.canSend = false
								time--
							}
						}, 1000 )
					} ).catch( err => {
						this.$message.warning( '验证码发送失败，請稍後再試' )
					} )
				}
				// }).catch(err =>{
				//   this.$message.warning('操作頻繁1，請稍後再試')
				// })
			},
			getInformation() {
				let loadingInstance = Loading.service( { fullscreen: true } );
				let _that = this
				userInformation().then( res => {
					if ( res ) {
						this.pay_phone = res.data.phone
						_that.surplus = res.data.user_money || 0;
						_that.is_counselor = res.data.is_counselor;
						loadingInstance.close()
					}
				} )
			},
			/*立即支付*/
			payShop( item ) {
				//判断是否登录
				ifSignIn( this, () => {
					//支付宝
//          if(this.radioS == 2){
					//余额
					if ( this.radioS == '餘額支付' ) {
						this.ifBalance = true
						return false
					} else {
						this.ifBalance = false
					}
					let merchant_url = 'https://www.verygrass.mo/pc/#/PaymentSuccess';
					if ( item.method.platform === '0' ) { //ips
						var payObj = {
							payment_method: item.method.method_val,
							merchant_url: merchant_url, // 使用
							// merchant_url:'http://testverygrass.cdabon.com/#/PaymentSuccess', // 使用
//              merchant_url:'正式https://www.verygrass.mo/#/PaymentSuccess',
//              merchant_url:'测试http://testverygrass.cdabon.com/#/PaymentSuccess', // test
						};
						payOrder( payObj, this.payMsg.id ).then( res => {
							this.formData = res.data;
						} )
					}
					if ( item.method.platform === '1' ) {//易汇金
						var payObj = {
							payment_method: item.method.method_val,
							merchant_url: merchant_url, // 使用
//            use_points:this.use_points
//            merchant_url:'http://localhost:8080/#/PaymentSuccess',
						};
						payOrder( payObj, this.payMsg.id ).then( res => {
							this.formData = res.data;
						} )
					}
					if ( item.method.platform === '2' ) {//hipopay
						var payObj = {
							payment_method: item.method.method_val,
							merchant_url: merchant_url, // 使用
//            use_points:this.use_points
//            merchant_url:'http://localhost:8080/#/PaymentSuccess',
						};
						payOrder( payObj, this.payMsg.id ).then( res => {
							this.formData = res.data;
						} )
					}
				} )
			},
			/*获取支付方式*/
			getPay() {
				getLocalStorage( 'orderMsg', ( res ) => {
					this.payMsg = res;
					this.ipsPaymentMethod[ 0 ].method = this.payMsg.payment_method.wechat_pay
					this.ipsPaymentMethod[ 1 ].method = this.payMsg.payment_method.alipay
					this.ipsPaymentMethod[ 2 ].method = this.payMsg.payment_method.union_pay
					this.ipsPaymentMethod[ 3 ].method = this.payMsg.payment_method.visa
					this.ipsPaymentMethod[ 4 ].method = this.payMsg.payment_method.master_card
					this.balance.method = this.payMsg.payment_method.balance
				} )
			},

			/*判断是否选择支付方式*/
			ifPay() {
				if ( this.radioS == '餘額支付' ) {
					this.dialogFormVisible = true
					return false
				}
				if ( this.radioS == undefined || this.radioS == null ) {
					this.$message.error( '請選擇支付方式' )
				} else if ( document.getElementById( 'ipspaysubmit' ) ) {
					setTimeout( () => {
						document.getElementById( 'ipspaysubmit' ).submit()
						sessionStorage.removeItem( 'purchaseData' );
					}, 20 )
				} else if ( document.getElementById( 'alipaysubmit' ) ) {
					setTimeout( () => {
						document.getElementById( 'alipaysubmit' ).submit()
						sessionStorage.removeItem( 'purchaseData' );
					}, 20 )
				} else if ( document.getElementById( 'hipopay' ) ) {
					this.$router.push( {
						path: `/orderPaymentQRcodePage?orderid=` + this.order + `&payment_method=` + document.getElementById( 'hipopay' ).getAttribute( "name" ),
					} )
				}

			},

			/*余额确认支付*/
			balanceConfirmation() {
				if ( md5( ( this.pay_code ).trim() ) != this.code ) {
					this.$message.error( '验证码错误，请重新输入' )
				} else {
					let loadingInstance = Loading.service( { fullscreen: true } );
//         checkPay({pay_password:this.pay_password}).then(res =>{
//           if(this.balance.method.platform === '0'){ // ips
//             var payObj = {
//               payment_method:this.balance.method.method_val,
//               merchant_url:'http://testverygrass.cdabon.com/#/PaymentSuccess',
//               code:res.data.code,
// //              use_points:this.use_points
//             }
//           } else if(this.balance.method.platform === '1') {
//             var payObj = {
//               payment_method:this.balance.method.method_val,
//               merchant_url:'http://testverygrass.cdabon.com/#/PaymentSuccess',
//               code:res.data.code,
// //              use_points:this.use_points
//             }
//           }
					var payObj = {
						payment_method: 5,
						merchant_url: 'https://www.verygrass.mo/pc/#/PaymentSuccess', // 使用
					}
					payOrder( payObj, this.payMsg.id ).then( res => {
						if ( res ) {
							loadingInstance.close()
						}
						this.$message.success( '支付成功' )
						this.$router.push( {
							name: 'PaymentSuccess',
							query: {
								amount: this.orderList.payment_amount
							}
						} )
						this.dialogFormVisible = false
					} ).catch( err => {
						if ( err ) {
							loadingInstance.close()
						}
					} )
					// }).catch(err =>{
					//   if (err){
					//     loadingInstance.close()
					//   }
					// })
				}
			},

			/*获取订单详情数据*/
			getOrderD() {
				orderMsg( this.order ).then( res => {
					this.orderList = res.data
					this.goodsData = res.data.goods.data
				} )
			}
		},
		created() {
			this.getInformation()
			//判断是否登录
			ifSignIn( this, () => {
			} );
			this.getPay();
			this.getOrderD()
			window.scrollTo( 0, 0 )
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .orderPayment {
    .success-information {
      text-align: left;
      width: 100%;

      .pay-newinformation {
        width: 100%;
        border: 1px solid #e5e5e5;
        padding: 50px 32px;
        color: #535353;
        background-color: initial;
        font-size: 16px;
        line-height: 26px;

        h5 {
          font-size: 22px;
          margin: 0 0 30px 0;
          border-bottom: 1px solid #eee;
          padding-bottom: 30px;

          span {
            display: inline-block;
            background: url(../../assets/icon/shop-success.png) no-repeat;
            width: 52px;
            height: 43px;
            vertical-align: middle;
          }
        }
      }

      .pay-newmoney {
        overflow: hidden;
        margin-top: 30px;
        font-size: 16px;

        span {
          line-height: 36px;

          b {
            font-size: 24px;
            color: #d01a42;
          }
        }
      }

      .pay_style {
        width: 100%;

        .wz {
          margin: 10px auto;

          .yue {
            text-align: center;
            width: 150px;
            height: 65px;
            font-size: 1.25em;
            font-weight: 600;
            line-height: 65px;
            display: inline-block;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
        }

        h4 {
          font-size: 20px;
          color: #535353;
          margin-bottom: 30px;
          margin-top: 60px;
          border-bottom: 1px solid #c9c9c9;
          padding-bottom: 10px;
        }
      }

      .pay_btnBox {
        .btn {
          width: 240px;
          margin: 30px 0 80px 0;
        }
      }
    }

    .radio {
      font-size: 16px;
      color: #d12147;

      /deep/ .el-radio__input {
        height: 65px;
        line-height: 0;
      }

      img {
        width: 45px;
        height: 40px;
      }

      .dang {
        position: absolute;
        margin-top: -20px;

        span {
          color: #d12147;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/detailsPage/OrderPayment.vue